/**
 * Converts a given string to a friendly URL format.
 *
 * @param {string} [value] - The string to be converted.
 */
export const toFriendlyUrlString = (value?: string) => {
    return value?.replace(/\W+/g, '-').toLowerCase() ?? ''
}
